var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { makeMultiSearch, makeSearch } from "../../UI/Search/Search";
import PersonPopulationLookupModal from "./PersonPopulationLookupModal";
import PopulationService from "../../../Services/Population.service";
import { ReactSelectLookupButton } from "../../UI/ReactSelectWithLookupModal/ReactSelectWithLookupModal";
import useService from "../../Hooks/useService";
import ServiceResult, { Loaders } from "../../UI/ServiceResult/ServiceResult";
import NumberService from "../../../Services/Shared/Number.service";
import ListService from "../../../Services/Shared/List.service";
import ModalHeader from "../../UI/Modal/ModalHeader";
import PersonPopulationMembersTable from "./PersonPopulationMembersTable";
import Modal from "../../UI/Modal/Modal";
import useCurrentApiUser from "../../Hooks/useCurrentApiUser";
import { ModalCloseButton } from "../../UI/StandardButtons/StandardButtons";
import FAIcon from "../../UI/FAIcon/FAIcon";
import ProfilePicture from "../Person/ProfilePicture/ProfilePicture";
const Details = ({ val, populationAdHocCaseloads, }) => {
    const [numPeopleState, getNumPeople] = useService(PopulationService.countForPersonPopulation);
    const isTemp = !ListService.isEmptyArray(populationAdHocCaseloads);
    React.useEffect(() => {
        if (val === null || val === void 0 ? void 0 : val.id) {
            const populationId = !isTemp && val.adHoc ? val.parentId : val.id;
            getNumPeople(populationId, {
                tempVals: isTemp
                    ? {
                        inPersonsCaseload: populationAdHocCaseloads === null || populationAdHocCaseloads === void 0 ? void 0 : populationAdHocCaseloads.map((person) => person.personId),
                    }
                    : {},
            });
        }
    }, [
        getNumPeople,
        isTemp,
        populationAdHocCaseloads,
        val === null || val === void 0 ? void 0 : val.adHoc,
        val === null || val === void 0 ? void 0 : val.id,
        val === null || val === void 0 ? void 0 : val.parentId,
    ]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    // If there's an error, we don't actually want to show anything.
    if (numPeopleState.hasError) {
        return null;
    }
    return (_jsx(_Fragment, { children: (val === null || val === void 0 ? void 0 : val.id) && (_jsxs(_Fragment, { children: [_jsx(ReactSelectLookupButton, { onClick: () => setIsModalOpen(true), title: "The number of people in the filter", children: _jsxs("span", { className: "d-flex align-items-center", children: [_jsx(ServiceResult, { state: numPeopleState, loader: Loaders.default({
                                    loaderSize: "sm",
                                    noLoadingMargin: true,
                                }), children: (numPeople) => NumberService.format(numPeople) }), _jsx(FAIcon, { icon: "user", className: "ml-2" })] }) }), _jsxs(Modal, { unMountContentWhenClosed: true, size: "xl", isOpen: isModalOpen, onModalClosed: () => {
                        setIsModalOpen(false);
                    }, children: [_jsx(ModalHeader, { title: val.name, closeModal: () => setIsModalOpen(false) }), _jsx("div", { className: "modal-body", children: _jsx(PersonPopulationMembersTable, { populationId: val.id, studentTempVals: !ListService.isEmptyArray(populationAdHocCaseloads)
                                    ? {
                                        inPersonsCaseload: populationAdHocCaseloads === null || populationAdHocCaseloads === void 0 ? void 0 : populationAdHocCaseloads.map((person) => person.personId),
                                    }
                                    : {} }) }), _jsx("div", { className: "modal-footer", children: _jsx(ModalCloseButton, { onClick: () => {
                                    setIsModalOpen(false);
                                } }) })] })] })) }));
};
const RenderSharedIcon = ({ owner }) => {
    return (_jsxs("div", { style: { position: "relative" }, className: "mx-2 mr-3", children: [_jsx(ProfilePicture, { person: owner, showProfilePicture: true, size: 25 }), _jsx("div", { style: {
                    position: "absolute",
                    top: -3,
                    right: -15,
                }, children: _jsxs("div", { className: "fa-stack fa-xs", children: [_jsx(FAIcon, { icon: "circle", type: "fas", className: "text-white fa-stack-2x" }), _jsx(FAIcon, { icon: "user-friends", className: "fa-stack-1x text-dark" })] }) })] }));
};
export const PersonPopulationOption = ({ population }) => {
    var _a, _b;
    const [parentPopulationState, loadParentPopulation] = useService(PopulationService.get);
    const currentUser = useCurrentApiUser();
    useEffect(() => {
        if (population.adHoc) {
            loadParentPopulation(population.parentId);
        }
    }, [loadParentPopulation, population.adHoc, population.parentId]);
    const isShared = currentUser != null && currentUser.id !== population.owner.personId;
    const isSharedAdHoc = population.adHoc &&
        ((_a = parentPopulationState.data) === null || _a === void 0 ? void 0 : _a.owner.personId) !== population.owner.personId;
    if (isShared || isSharedAdHoc) {
        return (_jsxs("div", { className: "d-flex align-items-center", title: `This is ${population.adHoc
                ? (_b = parentPopulationState.data) === null || _b === void 0 ? void 0 : _b.owner.fullName
                : population === null || population === void 0 ? void 0 : population.owner.fullName}'s filter shared with you.`, children: [population.name, population.adHoc ? (_jsx(ServiceResult, { state: parentPopulationState, loader: Loaders.hideLoader(), children: (parentPopulation) => (_jsx(RenderSharedIcon, { owner: parentPopulation.owner })) })) : (_jsx(RenderSharedIcon, { owner: population.owner }))] }));
    }
    return _jsx("div", { children: population.name });
};
const makeSearchArgs = {
    loadOptions: (search, options) => __awaiter(void 0, void 0, void 0, function* () {
        const { data } = yield PopulationService.search(Object.assign({ query: search }, options), {});
        // Group by person type.
        const grouped = ListService.groupByString(data !== null && data !== void 0 ? data : [], (pp) => pp.personType.name);
        return Object.keys(grouped).map((key) => ({
            label: key,
            options: grouped[key],
        }));
    }),
    formatOption: (population) => (_jsx(PersonPopulationOption, { population: population })),
    detailButton: Details,
    label: "name",
    value: "id",
};
export const PersonPopulationSearch = makeSearch(Object.assign({}, makeSearchArgs));
export const PersonPopulationMultiSearch = makeMultiSearch(Object.assign(Object.assign({}, makeSearchArgs), { lookupModal: PersonPopulationLookupModal }));
